/********************************************
* Media carousel
********************************************/
function fnMediaCarousel( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection								= $( oSection ),
		oCarousel								= $( '.carousel', oSection );

	/*****************
	* Image carousel
	*****************/

	// Return if no carousel
	if ( oCarousel.length > 0 ) {

		/**
		* Initialise Flickity
		*/
		var $oFlickity							= oCarousel.flickity( {
			wrapAround: 							true,
			bgLazyLoad: 							true,
			autoPlay: 								false,
			//autoPlay: 								5000,
			pauseAutoPlayOnHover: 					false,
			accessibility: 							false,
			percentPosition: 						false,
			prevNextButtons: 						true,
			arrowShape: { 
				x0: 15,
				x1: 65, y1: 50,
				x2: 73, y2: 42,
				x3: 32
			},
			pageDots: 								true,
			selectedAttraction: 					0.015,
			friction: 								0.3
		} );

		/**
		* Store carousel data
		*/
		var aCarouselData						= $oFlickity.data( 'flickity' );

		/**
		* Parallax images
		* NOTE: Does not work when 'wrapAround' is set to true
		*/
		var $oImages = $oFlickity.find('.image, video'),
			docStyle = document.documentElement.style,
			transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
		if ( $oImages.length > 2 ) {

			$oFlickity.on('scroll.flickity', function () {

				aCarouselData.slides.forEach(function (slide, i) {

					var oImage = $oImages[i],
						x = 0;

					if (0 === i) {
						x = Math.abs(aCarouselData.x) > aCarouselData.slidesWidth ? (aCarouselData.slidesWidth + aCarouselData.x + aCarouselData.slides[aCarouselData.slides.length - 1].outerWidth + slide.target) : (slide.target + aCarouselData.x);
					} else if (i === aCarouselData.slides.length - 1) {
						x = Math.abs(aCarouselData.x) + aCarouselData.slides[i].outerWidth < aCarouselData.slidesWidth ? (slide.target - aCarouselData.slidesWidth + aCarouselData.x - aCarouselData.slides[i].outerWidth) : (slide.target + aCarouselData.x);
					} else {
						x = slide.target + aCarouselData.x;
					}

					oImage.style[transformProp] = 'translateX(' + x * (-1 / 3) + 'px)';

				});

			});
		}

	}

}


// END OF DOCUMENT
